// next
// @mui
import { Divider, Paper, Stack, Typography } from '@mui/material';
import { m } from "framer-motion";
import NextLink from 'next/link';
import { ArticleProps } from 'src/@types/article';
import Routes from 'src/routes';
// components
import { TextMaxLine } from '../../components';
import Image from '../../components/NextSanityImage';
// utils
import { fDate } from '../../utils/formatTime';
// ----------------------------------------------------------------------

type Props = {
  article: ArticleProps;
};

export default function BlogPostItem({ article }: Props) {
  const { title, header, description, date, slug } = article;

  return (
    <Paper
      component={m.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
      variant="outlined"
      sx={{ borderRadius: 2, overflow: 'hidden' }}
    >
      <NextLink href={Routes.post('[slug]')} as={Routes.post(slug.current)}>
        <a>
          <Image src={header} sx={{ maxHeight: '50vh' }} alt={title} ratio="1/1" layout="intrinsic" width={500} height={500}
          />
        </a>
      </NextLink>

      <Stack direction="row" spacing={3} sx={{ p: 3 }}>
        <Stack sx={{ textAlign: 'center' }}>
          {date && (
            <>
              <Typography variant="subtitle2">{fDate(date, 'MMM')}</Typography>
              <Divider sx={{ mt: 1, mb: 0.5 }} />
              <Typography variant="h3">{fDate(date, 'dd')}</Typography>
            </>
          )}
        </Stack>

        <Stack spacing={1}>
          <NextLink passHref href={Routes.post('[slug]')} as={Routes.post(slug.current)}>
            <TextMaxLine variant="h6" asLink persistent>
              {title}
            </TextMaxLine>
          </NextLink>

          <TextMaxLine variant="body2" persistent color="text.secondary">
            {description}
          </TextMaxLine>
        </Stack>
      </Stack>
    </Paper>
  );
}
